import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Box, Typography, useTheme } from "@mui/material";
import Button from "./Button";
import { tokens } from "../../theme";

export type SimpleReleasePopupProps = {
  open: boolean;
  onReloadNow: () => void;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const SimpleReleasePopup: React.FC<SimpleReleasePopupProps> = ({
  open,
  onReloadNow,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="simple-release-dialog"
      aria-describedby="simple-release-description"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
          p: 0,
          border: "2px solid rgba(27, 27, 27, 0.3)",
          minWidth: { xs: "300px", sm: "400px", md: "500px" },
          minHeight: { xs: "250px", sm: "280px", md: "300px" },
          maxWidth: { xs: "90vw", sm: "80vw", md: "600px" },
        },
      }}
      maxWidth="md"
      
    >
      <DialogContent
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          background: "linear-gradient(to right,rgb(4, 35, 22), #151d23)",
          textAlign: "center",
          minHeight: { xs: "200px", sm: "230px", md: "250px" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "20px", sm: "22px", md: "24px" },
              mb: 3,
              color: "#FACC15",
            }}
          >
          You’re Almost There!
          </Typography>
          
          <Typography
            variant="body1"
            sx={{ 
              fontSize: { xs: "16px", sm: "17px", md: "18px" }, 
              color: "#E2E8F0", 
              mb: 4,
              lineHeight: 1.6
            }}
          >
            A quick refresh will get you started.
          </Typography>

          <Button
            color="success"
            onClick={onReloadNow}
            sx={{
              px: { xs: 4, sm: 5, md: 6 },
              py: { xs: 1.5, sm: 1.75, md: 2 },
              fontSize: { xs: "16px", sm: "17px", md: "18px" },
              fontWeight: "bold",
              borderRadius: "8px",
              background: "linear-gradient(90deg, #16a34a, #22c55e)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0px 4px 12px rgba(34, 197, 94, 0.3)",
                background: "linear-gradient(90deg, #15803d, #16a34a)",
              },
              "&:active": {
                transform: "translateY(0)",
                boxShadow: "0px 2px 6px rgba(34, 197, 94, 0.3)",
              },
            }}
          >
            Refresh Now
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SimpleReleasePopup;